import App from 'common/backbone-app';
import { getChatLocale } from 'common/support-chat/utils';

export type SupportChatConfig = {
  bootstrapJsSrc: string;
  init: {
    baseUrl: string;
    developerName: string;
    orgId: string;
    locale: string;
    rootElementId?: string;
  };
};

export function getSupportChatConfig(): SupportChatConfig {
  if (App.isProd) {
    return {
      bootstrapJsSrc: 'https://cdn1.treatwell.net/support-chat-assets/tw-one-chat.js',
      init: {
        orgId: '00D4L000000iBHI',
        developerName: 'Connect_Web',
        baseUrl: 'https://treatwell2021.my.salesforce-scrt.com',
        locale: getChatLocale(),
      },
    };
  }
  // development (https://treatwell2021--staging.sandbox.my.salesforce-setup.com/lightning/setup/EmbeddedServiceDeployments/04IS9000000C9sLMAS/view)
  return {
    bootstrapJsSrc:
      process.env.SUPPORT_CHAT_ASSET ||
      'https://cdn1.treatwell.net.staging.twtest.io/support-chat-assets/tw-one-chat.js',
    init: {
      orgId: '00DQ1000008G9Ni',
      developerName: 'Connect_Web',
      baseUrl: 'https://treatwell2021--staging.sandbox.my.salesforce-scrt.com',
      locale: getChatLocale(),
    },
  };
}
